import React, { useState } from 'react';
import Wheel from './Wheel';
import RecomendationSection from './RecomendationSection';
import OolaWheelMilestoneV2 from '../../PortalV2/Steps/OolaWheelMilestoneV2';
import GoalsWorkspaceV2 from '../../PortalV2/Steps/Goals/GoalsWorkspaceV2';
import ModalError from '../../../Components/Step2/SelectGoals/TemplateGoals/ModalError';
import ModalErrorV2 from '../../PortalV2/Modals/ModalErrorV2';
import './SelectGoalSection.css';

const SelectGoalSection = ({
    AllState,
    saveRecomendedGoals,
    mobile,
    portalV2,
}) => {
    const [showModalError, showModalErrorChange] = useState(false);
    const currentF = Number(AllState?.CurrentF);
    const activeIndex =
        Number.isFinite(currentF) && currentF >= 0 ? currentF : 0;
    const active = AllState?.Fs?.[activeIndex] || {};
    const next = AllState?.Fs?.[activeIndex + 1] || null;
    const lastReached = Number(AllState?.LastReachedF);
    const lastReachedIndex =
        Number.isFinite(lastReached) && lastReached >= 0 ? lastReached : 0;
    const focusScore =
        active.score != null && !Number.isNaN(Number(active.score))
            ? Number(active.score).toFixed(1)
            : null;

    const switchF = (index) => {
        if (index === AllState.CurrentF) return;
        if (index > AllState.LastReachedF) return;

        const fromF = AllState.CurrentF;
        AllState.changeData({
            ...AllState,
            CurrentF: index,
        });

        const hasGoals = AllState.SelectedGoals.some(
            (g) =>
                g.areaId === fromF && String(g.text || '').trim() !== ''
        );
        if (!hasGoals) return;

        saveRecomendedGoals({ areaId: fromF, silent: true }).then(
            (ok) => {
                if (!ok) showModalErrorChange(true);
            }
        );
    };

    if (!portalV2) {
        return (
            <section className="selectGoal__container">
                <div className="selectGoal__wrapper">
                    <div>
                        <Wheel AllState={AllState} hideNav={false} />
                    </div>
                    <div>
                        <RecomendationSection
                            AllState={AllState}
                            hideNav={false}
                            setShowError={showModalErrorChange}
                            show={showModalError}
                            saveRecomendedGoals={saveRecomendedGoals}
                            mobile={mobile}
                        />
                    </div>
                </div>
                <ModalError
                    ModalErrorTitle="Error connection"
                    ModalErrorDesc="Please verify your internet access, please try again"
                    setShowError={showModalErrorChange}
                    show={showModalError}
                />
            </section>
        );
    }

    return (
        <section className="selectGoal__container selectGoal__container--v2">
            <div className="selectGoal__wrapper selectGoal__wrapper--v2">
                <aside className="selectGoal__side">
                    <div className="selectGoal__wheelV2">
                        <OolaWheelMilestoneV2
                            Fs={AllState.Fs || []}
                            activeIndex={activeIndex}
                            nextName={next?.name}
                            nextColor={next?.color}
                            focusScore={focusScore}
                            goalProgress
                            lastReachedIndex={lastReachedIndex}
                            onSelectF={switchF}
                        />
                    </div>
                </aside>

                <div className="selectGoal__workspace">
                    <GoalsWorkspaceV2
                        AllState={AllState}
                        saveRecomendedGoals={saveRecomendedGoals}
                        onSelectF={switchF}
                        lastReachedIndex={lastReachedIndex}
                    />
                </div>
            </div>
            <ModalErrorV2
                ModalErrorTitle="Couldn’t save goals"
                ModalErrorDesc="Please check your connection and try again."
                setShowError={showModalErrorChange}
                show={showModalError}
            />
        </section>
    );
};

export default SelectGoalSection;
